var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBidding1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 73,
    viewBox: "0 0 236 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_191_15451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.46924,
    y: 0.916016,
    width: 27.6003,
    height: 34.7764,
    rx: 13.8002,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7107 24.644C21.6003 24.644 21.5009 24.6054 21.4126 24.5281C21.3353 24.4398 21.2967 24.3404 21.2967 24.23V16.3474L19.0279 18.0862C18.9286 18.1635 18.8237 18.1911 18.7133 18.169C18.6139 18.1469 18.5256 18.0862 18.4483 17.9868L17.4713 16.7117C17.405 16.6123 17.3774 16.5075 17.3885 16.3971C17.4106 16.2756 17.4768 16.1818 17.5872 16.1155L21.396 13.1678C21.4623 13.1237 21.523 13.0961 21.5782 13.085C21.6445 13.0629 21.7162 13.0519 21.7935 13.0519H23.8635C23.985 13.0519 24.0843 13.0905 24.1616 13.1678C24.2389 13.2451 24.2775 13.3445 24.2775 13.4659V24.23C24.2775 24.3404 24.2389 24.4398 24.1616 24.5281C24.0843 24.6054 23.985 24.644 23.8635 24.644H21.7107Z",
    fill: "#382956"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_191_15451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.6694,
    y: 0.916016,
    width: 27.6003,
    height: 34.7764,
    rx: 13.8002,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1637 24.644C49.0423 24.644 48.9374 24.6054 48.8491 24.5281C48.7718 24.4398 48.7332 24.3404 48.7332 24.23V23.0543C48.7332 22.977 48.7553 22.8611 48.7994 22.7065C48.8436 22.5409 48.9595 22.3863 49.1472 22.2428L50.8694 20.5537C51.7527 19.8802 52.4758 19.3117 53.0388 18.848C53.6129 18.3732 54.038 17.9537 54.314 17.5894C54.59 17.2251 54.728 16.8828 54.728 16.5627C54.728 16.1873 54.6286 15.8782 54.4299 15.6353C54.2422 15.3814 53.911 15.2544 53.4363 15.2544C53.1161 15.2544 52.8511 15.3262 52.6414 15.4697C52.4316 15.6022 52.266 15.7788 52.1446 15.9996C52.0342 16.2204 51.9569 16.4467 51.9127 16.6786C51.8686 16.8221 51.7913 16.9215 51.6809 16.9767C51.5815 17.0319 51.4711 17.0595 51.3497 17.0595H49.2797C49.1803 17.0595 49.0975 17.0264 49.0313 16.9601C48.965 16.8939 48.9319 16.8111 48.9319 16.7117C48.9429 16.1818 49.0533 15.685 49.2631 15.2213C49.4839 14.7466 49.7875 14.3326 50.1739 13.9793C50.5714 13.626 51.0406 13.35 51.5815 13.1513C52.1335 12.9415 52.7518 12.8366 53.4363 12.8366C54.3747 12.8366 55.1696 12.9912 55.8209 13.3003C56.4833 13.5984 56.9857 14.0179 57.3279 14.5589C57.6702 15.0888 57.8413 15.7126 57.8413 16.4302C57.8413 16.9712 57.7198 17.479 57.477 17.9537C57.2451 18.4174 56.9084 18.8645 56.4668 19.2951C56.0362 19.7146 55.5229 20.1507 54.9267 20.6034L53.4032 22.1435H57.6591C57.7806 22.1435 57.8799 22.1821 57.9572 22.2594C58.0455 22.3367 58.0897 22.436 58.0897 22.5575V24.23C58.0897 24.3404 58.0455 24.4398 57.9572 24.5281C57.8799 24.6054 57.7806 24.644 57.6591 24.644H49.1637Z",
    fill: "#382956"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_191_15451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.8701,
    y: 0.916016,
    width: 27.6003,
    height: 34.7764,
    rx: 13.8002,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5642 24.8096C84.7141 24.8096 83.9799 24.7103 83.3617 24.5116C82.7545 24.3018 82.2577 24.0368 81.8713 23.7167C81.4849 23.3855 81.1978 23.0377 81.0101 22.6734C80.8224 22.298 80.7231 21.9392 80.712 21.597C80.712 21.4976 80.7452 21.4148 80.8114 21.3486C80.8887 21.2823 80.977 21.2492 81.0764 21.2492H83.2458C83.3672 21.2492 83.4666 21.2768 83.5438 21.332C83.6211 21.3762 83.6929 21.4534 83.7591 21.5638C83.8474 21.7736 83.9744 21.9447 84.14 22.0772C84.3166 22.2097 84.5264 22.3035 84.7693 22.3587C85.0122 22.4029 85.2771 22.425 85.5642 22.425C86.1272 22.425 86.5633 22.298 86.8724 22.0441C87.1926 21.7791 87.3527 21.4203 87.3527 20.9677C87.3527 20.493 87.2036 20.1562 86.9056 19.9575C86.6075 19.7477 86.1824 19.6429 85.6304 19.6429H83.7922C83.6708 19.6429 83.5714 19.6042 83.4942 19.5269C83.4169 19.4497 83.3782 19.3503 83.3782 19.2289V18.3015C83.3782 18.169 83.4058 18.0531 83.461 17.9537C83.5162 17.8544 83.577 17.7826 83.6432 17.7384L86.3591 15.4366H81.7553C81.6449 15.4366 81.5456 15.3979 81.4573 15.3207C81.38 15.2434 81.3413 15.144 81.3413 15.0226V13.4659C81.3413 13.3445 81.38 13.2451 81.4573 13.1678C81.5456 13.0905 81.6449 13.0519 81.7553 13.0519H89.373C89.4945 13.0519 89.5938 13.0905 89.6711 13.1678C89.7594 13.2451 89.8036 13.3445 89.8036 13.4659V14.8735C89.8036 14.995 89.776 15.1054 89.7208 15.2047C89.6656 15.293 89.6049 15.3648 89.5386 15.42L87.0215 17.755L87.1374 17.7881C87.7777 17.8654 88.3408 18.031 88.8265 18.2849C89.3233 18.5388 89.7153 18.9032 90.0023 19.3779C90.2894 19.8416 90.4329 20.4322 90.4329 21.1498C90.4329 21.9006 90.2176 22.5519 89.787 23.1039C89.3675 23.6449 88.7934 24.0644 88.0648 24.3625C87.3361 24.6606 86.5026 24.8096 85.5642 24.8096Z",
    fill: "#382956"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_191_15451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.07,
    y: 0.916016,
    width: 27.6003,
    height: 34.7764,
    rx: 13.8002,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.63 24.644C118.52 24.644 118.42 24.6054 118.332 24.5281C118.255 24.4398 118.216 24.3404 118.216 24.23V22.3587H113.066C112.956 22.3587 112.856 22.3201 112.768 22.2428C112.691 22.1655 112.652 22.0662 112.652 21.9447V20.3715C112.652 20.2721 112.668 20.1838 112.702 20.1065C112.746 20.0182 112.79 19.9354 112.834 19.8581L117.653 13.3334C117.797 13.1457 118.001 13.0519 118.266 13.0519H120.684C120.794 13.0519 120.888 13.0905 120.965 13.1678C121.053 13.2451 121.098 13.3445 121.098 13.4659V19.8913H122.555C122.687 19.8913 122.792 19.9354 122.87 20.0237C122.947 20.101 122.985 20.1949 122.985 20.3053V21.9447C122.985 22.0662 122.941 22.1655 122.853 22.2428C122.776 22.3201 122.682 22.3587 122.571 22.3587H121.098V24.23C121.098 24.3404 121.053 24.4398 120.965 24.5281C120.888 24.6054 120.794 24.644 120.684 24.644H118.63ZM115.5 20.0072H118.282V16.099L115.5 20.0072Z",
    fill: "#382956"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_191_15451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.271,
    y: 0.916016,
    width: 27.6003,
    height: 34.7764,
    rx: 13.8002,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.987 24.8262C148.95 24.8262 148.083 24.6661 147.387 24.346C146.692 24.0148 146.162 23.5897 145.798 23.0708C145.444 22.5409 145.257 21.9723 145.235 21.3651C145.235 21.2658 145.268 21.183 145.334 21.1167C145.4 21.0505 145.483 21.0174 145.582 21.0174H147.801C147.945 21.0174 148.055 21.045 148.133 21.1002C148.221 21.1554 148.287 21.2326 148.331 21.332C148.431 21.5859 148.563 21.7957 148.729 21.9613C148.894 22.1269 149.082 22.2483 149.292 22.3256C149.502 22.4029 149.739 22.4415 150.004 22.4415C150.313 22.4415 150.6 22.3753 150.865 22.2428C151.13 22.1103 151.34 21.9171 151.494 21.6632C151.66 21.3982 151.743 21.0836 151.743 20.7193C151.743 20.3881 151.665 20.101 151.511 19.8581C151.367 19.6153 151.163 19.4221 150.898 19.2785C150.644 19.135 150.346 19.0633 150.004 19.0633C149.739 19.0633 149.524 19.0964 149.358 19.1626C149.192 19.2178 149.054 19.2896 148.944 19.3779C148.834 19.4662 148.734 19.5435 148.646 19.6097C148.558 19.6649 148.458 19.6925 148.348 19.6925H146.179C146.079 19.6925 145.991 19.6594 145.914 19.5932C145.847 19.5159 145.814 19.4276 145.814 19.3282L146.41 13.5487C146.432 13.3831 146.493 13.2617 146.593 13.1844C146.692 13.0961 146.813 13.0519 146.957 13.0519H153.598C153.719 13.0519 153.818 13.0905 153.896 13.1678C153.984 13.2451 154.028 13.3445 154.028 13.4659V15.0226C154.028 15.144 153.984 15.2434 153.896 15.3207C153.818 15.3979 153.719 15.4366 153.598 15.4366H148.795L148.58 17.5728C148.823 17.4183 149.104 17.2858 149.424 17.1754C149.756 17.065 150.208 17.0098 150.782 17.0098C151.301 17.0098 151.798 17.1036 152.273 17.2913C152.758 17.468 153.189 17.7219 153.564 18.0531C153.951 18.3843 154.249 18.7817 154.459 19.2454C154.679 19.6981 154.79 20.2114 154.79 20.7855C154.79 21.5694 154.597 22.2649 154.21 22.8721C153.835 23.4793 153.288 23.9596 152.571 24.3128C151.853 24.6551 150.992 24.8262 149.987 24.8262Z",
    fill: "#382956"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_191_15451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168.471,
    y: 0.916016,
    width: 27.6003,
    height: 34.7764,
    rx: 13.8002,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.329 24.8096C181.347 24.8096 180.486 24.633 179.746 24.2797C179.006 23.9264 178.427 23.4407 178.007 22.8224C177.599 22.1931 177.394 21.4755 177.394 20.6696C177.394 20.3274 177.444 19.9906 177.543 19.6594C177.654 19.3172 177.786 18.997 177.941 18.6989C178.095 18.3898 178.25 18.1193 178.405 17.8875C178.559 17.6446 178.686 17.4514 178.785 17.3079L181.7 13.3831C181.755 13.3279 181.827 13.2617 181.915 13.1844C182.004 13.0961 182.131 13.0519 182.296 13.0519H184.499C184.598 13.0519 184.681 13.0905 184.747 13.1678C184.813 13.2341 184.846 13.3169 184.846 13.4162C184.846 13.4604 184.841 13.5045 184.83 13.5487C184.819 13.5818 184.802 13.6094 184.78 13.6315L182.545 16.6786C182.611 16.6565 182.688 16.6455 182.776 16.6455C182.876 16.6344 182.964 16.6289 183.041 16.6289C183.538 16.651 184.029 16.7614 184.515 16.9601C185.001 17.1588 185.443 17.4293 185.84 17.7716C186.238 18.1138 186.552 18.5278 186.784 19.0136C187.027 19.4883 187.148 20.0182 187.148 20.6034C187.148 21.3762 186.95 22.0827 186.552 22.7231C186.155 23.3523 185.592 23.8602 184.863 24.2466C184.145 24.622 183.301 24.8096 182.329 24.8096ZM182.296 22.425C182.616 22.425 182.914 22.3587 183.19 22.2263C183.466 22.0827 183.687 21.8785 183.853 21.6135C184.029 21.3486 184.118 21.0284 184.118 20.653C184.118 20.2666 184.035 19.9465 183.869 19.6925C183.704 19.4276 183.483 19.2289 183.207 19.0964C182.931 18.9639 182.627 18.8977 182.296 18.8977C181.965 18.8977 181.656 18.9639 181.369 19.0964C181.093 19.2289 180.872 19.4276 180.706 19.6925C180.541 19.9465 180.458 20.2666 180.458 20.653C180.458 21.0284 180.541 21.3486 180.706 21.6135C180.883 21.8785 181.109 22.0827 181.385 22.2263C181.661 22.3587 181.965 22.425 182.296 22.425Z",
    fill: "#382956"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_191_15451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.671,
    y: 0.916016,
    width: 27.6003,
    height: 34.7764,
    rx: 13.8002,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.03 24.644C211.931 24.644 211.848 24.6109 211.782 24.5447C211.715 24.4674 211.682 24.3791 211.682 24.2797C211.682 24.2356 211.693 24.1859 211.715 24.1307L215.541 15.5525H210.589C210.468 15.5525 210.363 15.5139 210.275 15.4366C210.197 15.3483 210.159 15.2434 210.159 15.1219V13.4659C210.159 13.3445 210.197 13.2451 210.275 13.1678C210.363 13.0905 210.468 13.0519 210.589 13.0519H218.323C218.455 13.0519 218.56 13.0905 218.637 13.1678C218.715 13.2451 218.753 13.3445 218.753 13.4659V14.9398C218.753 15.1054 218.737 15.2434 218.704 15.3538C218.671 15.4642 218.626 15.5746 218.571 15.685L214.746 24.2466C214.713 24.3128 214.652 24.3956 214.564 24.495C214.475 24.5944 214.343 24.644 214.166 24.644H212.03Z",
    fill: "#382956"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_191_15451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.46924,
    y: 41.2124,
    width: 39.7445,
    height: 30.9124,
    rx: 15.4562,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8728 64.9489C24.5197 64.9489 24.3279 64.5347 24.5556 64.264L27.3413 60.9519V64.9489H24.8728Z",
    fill: "#1EA072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8099 64.9489C30.1629 64.9489 30.3547 64.5347 30.1271 64.264L27.3413 60.9519V64.9489H29.8099Z",
    fill: "#1EA072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9414 52.0002C30.9414 53.9948 29.3296 55.6118 27.3414 55.6118C25.3531 55.6118 23.7413 53.9948 23.7413 52.0002C23.7413 50.0056 25.3531 48.3887 27.3414 48.3887C29.3296 48.3887 30.9414 50.0056 30.9414 52.0002Z",
    fill: "#1EA072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7094 58.6834C25.7094 60.678 24.0976 62.295 22.1093 62.295C20.1211 62.295 18.5093 60.678 18.5093 58.6834C18.5093 56.6888 20.1211 55.0718 22.1093 55.0718C24.0976 55.0718 25.7094 56.6888 25.7094 58.6834Z",
    fill: "#1EA072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1735 58.6834C36.1735 60.678 34.5617 62.295 32.5734 62.295C30.5852 62.295 28.9734 60.678 28.9734 58.6834C28.9734 56.6888 30.5852 55.0718 32.5734 55.0718C34.5617 55.0718 36.1735 56.6888 36.1735 58.6834Z",
    fill: "#1EA072"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii_191_15451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.7339,
    y: 41.2124,
    width: 39.7445,
    height: 30.9124,
    rx: 15.4562,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2646 57.219C63.9606 56.9151 63.9606 56.4223 64.2646 56.1184L72.0559 48.3271C72.3598 48.0231 72.8526 48.0231 73.1565 48.3271L80.9478 56.1184C81.2517 56.4223 81.2517 56.9151 80.9478 57.219L73.1565 65.0103C72.8526 65.3142 72.3598 65.3142 72.0559 65.0103L64.2646 57.219Z",
    fill: "#F7931D"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ii_191_15451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.9985,
    y: 41.2124,
    width: 39.7445,
    height: 30.9124,
    rx: 15.4562,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.679 49.001C115.682 49.001 116.943 50.3442 117.871 52.0232V64.336C111.082 60.6795 109.301 56.0902 109.301 53.4784C109.301 50.8666 111.676 49.001 113.679 49.001Z",
    fill: "#DD312E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.063 49.001C120.06 49.001 118.798 50.3442 117.871 52.0232V64.336C124.66 60.6795 126.44 56.0902 126.44 53.4784C126.44 50.8666 124.066 49.001 122.063 49.001Z",
    fill: "#DD312E"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_ii_191_15451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.263,
    y: 41.2124,
    width: 39.7445,
    height: 30.9124,
    rx: 15.4562,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.274 62.055C161.119 62.055 162.28 60.8523 163.135 59.349V48.3247C156.882 51.5986 155.242 55.7076 155.242 58.0461C155.242 60.3846 157.429 62.055 159.274 62.055Z",
    fill: "#4176DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.996 62.055C165.151 62.055 163.989 60.8523 163.135 59.349V48.3247C169.388 51.5986 171.028 55.7076 171.028 58.0461C171.028 60.3846 168.841 62.055 166.996 62.055Z",
    fill: "#4176DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.92 65.0128C160.604 65.0128 160.431 64.6496 160.636 64.4122L163.135 61.5072V65.0128H160.92Z",
    fill: "#4176DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.349 65.0128C165.666 65.0128 165.838 64.6496 165.634 64.4122L163.135 61.5072V65.0128H165.349Z",
    fill: "#4176DE"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_ii_191_15451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.527,
    y: 41.2124,
    width: 39.7445,
    height: 30.9124,
    rx: 15.4562,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.266 62.7324C199.144 62.7324 199.045 62.6938 198.968 62.6165C198.89 62.5282 198.852 62.4288 198.852 62.3184V51.5543C198.852 51.4328 198.89 51.3335 198.968 51.2562C199.045 51.1789 199.144 51.1403 199.266 51.1403H201.021C201.209 51.1403 201.341 51.1844 201.419 51.2728C201.507 51.35 201.562 51.4108 201.584 51.4549L205.625 57.814V51.5543C205.625 51.4328 205.664 51.3335 205.741 51.2562C205.818 51.1789 205.917 51.1403 206.039 51.1403H208.026C208.148 51.1403 208.247 51.1789 208.324 51.2562C208.401 51.3335 208.44 51.4328 208.44 51.5543V62.3019C208.44 62.4233 208.401 62.5282 208.324 62.6165C208.247 62.6938 208.148 62.7324 208.026 62.7324H206.254C206.078 62.7324 205.945 62.6883 205.857 62.5999C205.779 62.5116 205.73 62.4509 205.708 62.4178L201.667 56.2905V62.3184C201.667 62.4288 201.628 62.5282 201.551 62.6165C201.474 62.6938 201.374 62.7324 201.253 62.7324H199.266ZM213.719 62.7324C213.597 62.7324 213.498 62.6938 213.421 62.6165C213.343 62.5282 213.305 62.4288 213.305 62.3184V53.7402H210.357C210.236 53.7402 210.136 53.7016 210.059 53.6243C209.982 53.536 209.943 53.4366 209.943 53.3262V51.5543C209.943 51.4328 209.982 51.3335 210.059 51.2562C210.136 51.1789 210.236 51.1403 210.357 51.1403H219.266C219.388 51.1403 219.487 51.1789 219.564 51.2562C219.642 51.3335 219.68 51.4328 219.68 51.5543V53.3262C219.68 53.4366 219.642 53.536 219.564 53.6243C219.487 53.7016 219.388 53.7402 219.266 53.7402H216.319V62.3184C216.319 62.4288 216.28 62.5282 216.203 62.6165C216.125 62.6938 216.026 62.7324 215.905 62.7324H213.719Z",
    fill: "#382956"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_191_15451",
    x: 7.46924,
    y: 0.364009,
    width: 28.1521,
    height: 36.4324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.552007,
    dy: 1.10401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552007
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_191_15451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_191_15451",
    result: "effect2_innerShadow_191_15451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_191_15451",
    x: 39.6694,
    y: 0.364009,
    width: 28.1521,
    height: 36.4324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.552007,
    dy: 1.10401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552007
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_191_15451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_191_15451",
    result: "effect2_innerShadow_191_15451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_191_15451",
    x: 71.8701,
    y: 0.364009,
    width: 28.1521,
    height: 36.4324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.552007,
    dy: 1.10401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552007
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_191_15451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_191_15451",
    result: "effect2_innerShadow_191_15451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_191_15451",
    x: 104.07,
    y: 0.364009,
    width: 28.1521,
    height: 36.4324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.552007,
    dy: 1.10401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552007
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.408291 0 0 0 0 0.274938 0 0 0 0 0.691667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_191_15451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_191_15451",
    result: "effect2_innerShadow_191_15451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_191_15451",
    x: 136.271,
    y: 0.364009,
    width: 28.1521,
    height: 36.4324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.552007,
    dy: 1.10401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552007
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_191_15451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_191_15451",
    result: "effect2_innerShadow_191_15451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_191_15451",
    x: 168.471,
    y: 0.364009,
    width: 28.1521,
    height: 36.4324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.552007,
    dy: 1.10401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552007
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_191_15451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_191_15451",
    result: "effect2_innerShadow_191_15451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_191_15451",
    x: 200.671,
    y: 0.364009,
    width: 28.1521,
    height: 36.4324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.552007,
    dy: 1.10401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552007
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_191_15451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_191_15451",
    result: "effect2_innerShadow_191_15451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_191_15451",
    x: 7.46924,
    y: 40.6604,
    width: 40.2966,
    height: 32.5686,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.552007,
    dy: 1.10401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552007
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.408291 0 0 0 0 0.274938 0 0 0 0 0.691667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_191_15451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_191_15451",
    result: "effect2_innerShadow_191_15451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_191_15451",
    x: 52.7339,
    y: 40.6604,
    width: 40.2966,
    height: 32.5686,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.552007,
    dy: 1.10401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552007
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_191_15451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_191_15451",
    result: "effect2_innerShadow_191_15451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ii_191_15451",
    x: 97.9985,
    y: 40.6604,
    width: 40.2966,
    height: 32.5686,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.552007,
    dy: 1.10401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552007
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_191_15451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_191_15451",
    result: "effect2_innerShadow_191_15451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_ii_191_15451",
    x: 143.263,
    y: 40.6604,
    width: 40.2966,
    height: 32.5686,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.552007,
    dy: 1.10401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552007
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_191_15451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_191_15451",
    result: "effect2_innerShadow_191_15451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_ii_191_15451",
    x: 188.527,
    y: 40.6604,
    width: 40.2966,
    height: 32.5686,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.552007,
    dy: 1.10401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552007
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_191_15451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.552007
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.82801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_191_15451",
    result: "effect2_innerShadow_191_15451"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidding1);
export default __webpack_public_path__ + "static/media/bidding1.2b5eabe190e5c9566138a0707c29ba86.svg";
export { ForwardRef as ReactComponent };